import { createActions, createReducer } from 'reduxsauce'
import moment from 'moment'
import _ from 'lodash'

const { Types, Creators } = createActions({
    //NOTE: Do not pass the keyword "type" as an argument, as it will override the action type name.
    getTransactions: ['supplierId', 'nextToken'],
    getTransactionsSuccess: ['transactions', 'resources', 'nextToken'],
    getTransactionsFailure: ['transactionsError'],

    selectAllTransactions: [],
    selectPendingTransactions: [],
    selectTransaction: ['transaction'],
    openTransaction: ['transaction'],

    updateTransaction: ['state', 'transaction', 'history'],
    updateTransactionSuccess: ['transaction'],
    updateTransactionFailure: [],

    askForHelp: ['answers', 'transaction', 'callback'],
    askForHelpSuccess: [],
    askForHelpFailure: ['askForHelpError'],

    cancelOrder: ['body', 'callback'],
    cancelOrderSuccess: ['transactionId'],
    cancelOrderFailure: [],
})

export const TransactionsTypes = Types

const INITIAL_STATE = {
    transactions: [],
    pendingTransactions: 0,
    transactionListByMonth: {},
    transactionsError: null,
    loadingTransactions: true,
    transactionsToExport: [],
    openedTransaction: null,
    loadingUpdateTransaction: false,
    loadingAskForHelp: false,
    askForHelpError: null,
    loadingCancelOrder: false,
}

const transformTransactions = transactionsList => {
    let transactionListByMonth = {}
    let pendingTransactions = 0
    let uniqueTransactions = _.uniqBy(transactionsList, transaction => transaction.transactionId)
    uniqueTransactions.sort((a, b) => moment(b.date).unix() - moment(a.date).unix())
    uniqueTransactions.forEach(transaction => {
        // Group transactions into months
        const date = moment(transaction.date).format('MMM YYYY')

        if (!(date in transactionListByMonth)) {
            transactionListByMonth[date] = {}
            transactionListByMonth[date].transactions = []
            transactionListByMonth[date].total = 0
        }
        transactionListByMonth[date].transactions.push(transaction)
        transactionListByMonth[date].total += parseInt(transaction.price)

        // Increment pending counter
        if (transaction.state === 'PENDING') {
            pendingTransactions++
        }
    })

    return { transactionListByMonth, pendingTransactions }
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_TRANSACTIONS]: state => ({ ...state, loadingTransactions: true }),
    [Types.GET_TRANSACTIONS_SUCCESS]: (state, { transactions, resources, nextToken }) => {
        const newTransactions = [...transactions]
        const transactionsWithDetails = []
        newTransactions.forEach(trans => {
            const resource = resources.filter(({ resourceId }) => resourceId === trans.resourceId)
            transactionsWithDetails.push({
                ...trans,
                address:
                    trans.address && trans.address !== '"n/a"' && trans.address !== '[{}]'
                        ? JSON.parse(JSON.parse(trans.address))?.[0] || {}
                        : { mobile: '', name: '', postcode: '', secondLine: '', city: '', firstLine: '' },
                imageThumbS: resource.length && 'imageThumbS' in resource[0] ? resource[0].imageThumbS : '',
            })
        })
        let realTransactions = transactionsWithDetails.filter(({ showType }) => showType !== false)
        let allTransactions = [...state.transactions, ...realTransactions]
        allTransactions = _.uniqBy(allTransactions, transaction => transaction.transactionId)

        if (!nextToken) {
            //only after all the transactions are received we call transformTransactions
            const { transactionListByMonth, pendingTransactions } = transformTransactions([...state.transactions, ...realTransactions])
            return {
                ...state,
                pendingTransactions,
                transactionListByMonth,
                transactions: allTransactions,
                loadingTransactions: false,
                transactionsError: null,
            }
        }

        return {
            //loadingTranasctions should stay true
            ...state,
            transactions: [...state.transactions, ...realTransactions],
            transactionsError: null,
        }
    },
    [Types.GET_TRANSACTIONS_FAILURE]: (state, { transactionsError }) => ({
        ...state,
        loadingTransactions: false,
        transactionListByMonth: {},
        pendingTransactions: 0,
        transactionsError,
    }),

    [Types.SELECT_ALL_TRANSACTIONS]: state => ({ ...state, transactionsToExport: state.transactions }),
    [Types.SELECT_PENDING_TRANSACTIONS]: state => ({ ...state, transactionsToExport: state.transactions.filter(({ state }) => state === 'PENDING') }),
    [Types.SELECT_TRANSACTION]: (state, { transaction }) => ({
        ...state,
        transactionsToExport: state.transactionsToExport.filter(trans => trans.transactionId === transaction.transactionId).length
            ? state.transactionsToExport.filter(trans => trans.transactionId !== transaction.transactionId)
            : [...state.transactionsToExport, transaction],
    }),
    [Types.OPEN_TRANSACTION]: (state, { transaction }) => ({
        ...state,
        openedTransaction: transaction,
    }),

    [Types.UPDATE_TRANSACTION]: state => ({
        ...state,
        loadingUpdateTransaction: true,
    }),
    [Types.UPDATE_TRANSACTION_SUCCESS]: (state, { transaction }) => {
        const transactions = state.transactions.map(item => {
            const { transactionId, state, deliveryCompany, deliveryTrackingNumber } = transaction
            if (item.transactionId === transactionId) {
                item = { ...item, state, deliveryCompany, deliveryTrackingNumber }
            }
            return item
        })
        const { transactionListByMonth, pendingTransactions } = transformTransactions(transactions)
        return {
            ...state,
            loadingUpdateTransaction: false,
            transactions,
            transactionListByMonth,
            pendingTransactions,
        }
    },
    [Types.UPDATE_TRANSACTION_FAILURE]: state => ({
        ...state,
        loadingUpdateTransaction: false,
    }),

    [Types.ASK_FOR_HELP]: state => ({
        ...state,
        loadingAskForHelp: true,
    }),
    [Types.ASK_FOR_HELP_SUCCESS]: state => ({
        ...state,
        loadingAskForHelp: false,
        askForHelpError: null,
    }),
    [Types.ASK_FOR_HELP_FAILURE]: (state, { askForHelpError }) => ({
        ...state,
        loadingAskForHelp: false,
        askForHelpError,
    }),

    [Types.CANCEL_ORDER]: state => ({
        ...state,
        loadingCancelOrder: true,
    }),
    [Types.CANCEL_ORDER_SUCCESS]: (state, { transactionId }) => {
        let transactions = state.transactions.map(item => {
            if (item.transactionId === transactionId) {
                item.state = 'CANCELLED'
                return item
            } else {
                return item
            }
        })
        return {
            ...state,
            loadingCancelOrder: false,
            transactions: transactions,
        }
    },
    [Types.CANCEL_ORDER_FAILURE]: state => ({
        ...state,
        loadingCancelOrder: false,
    }),
})

export default Creators
